import { defineComponent } from 'vue'
import styles from './index.module.scss';

export default defineComponent(() => {
    return () => <div class={[styles.loading, 'lds-ring']} ><div></div><div></div><div></div><div></div></div>
})